import { TriangleAlert } from 'lucide-react'

import { ICGG2Report } from '@fortem-monorepo/web-sdk'

import { formatIdentifierValue } from '@/pages/funds/ic-guidelines-v2/components/stages/breaches-stage/breaches-utils'

export interface GuidelineIssuesProps {
  result: ICGG2Report.GuidelineResult
}

const compactRow = (row: Record<string, unknown>) => {
  return Object.entries(row)
    .slice(0, 6)
    .map(([key, value]) => `${key}: ${formatIdentifierValue(value)}`)
    .join(' | ')
}

export const GuidelineIssues: React.FC<GuidelineIssuesProps> = ({ result }) => {
  if (!result.issues.length) return null

  return (
    <div className={'rounded-md border border-blue-200 bg-blue-50 p-3'}>
      <div className={'mb-2 flex items-center gap-2 text-sm font-medium text-blue-700'}>
        <TriangleAlert className={'size-4'} />
        Evaluation issues
      </div>
      <div className={'space-y-2'}>
        {result.issues.map((issue, index) => (
          <div key={`${issue.message}-${index}`} className={'text-xs text-blue-950'}>
            <div>{issue.message}</div>
            {issue.row && (
              <div className={'mt-1 font-mono text-[11px] text-blue-700'}>
                {compactRow(issue.row)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
